/**
 * Admin-only visual preview of the public gift card, rendered from STATIC fake
 * data. It mints nothing, calls no endpoint and exposes no public fake route.
 */
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { LuxuryGiftCard } from '@/components/gift/LuxuryGiftCard';
import { DEMO_GIFT_CARD, DEMO_GIFT_CARD_NO_BALANCE } from '@/components/gift/demoGiftCard';

export default function AdminGiftCardPreview() {
  return (
    <div dir="rtl" className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-medium">תצוגה מקדימה של השובר</h1>
          <p className="text-sm text-muted-foreground">נתוני דמו בלבד — לא נוצר שובר ולא נשלח דבר.</p>
        </div>
        <Link to="/admin/gift-cards" className="inline-flex items-center gap-1 text-sm hover:underline">
          חזרה לשוברים <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>

      <section className="rounded-2xl overflow-hidden">
        <div className="lux-page" style={{ minHeight: 'auto' }}>
          <LuxuryGiftCard data={DEMO_GIFT_CARD} />
        </div>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-medium">מצב: יתרה אינה זמינה זמנית</h2>
        <div className="rounded-2xl overflow-hidden">
          <div className="lux-page" style={{ minHeight: 'auto' }}>
            <LuxuryGiftCard data={DEMO_GIFT_CARD_NO_BALANCE} />
          </div>
        </div>
      </section>
    </div>
  );
}
